import { useState, useCallback, useEffect } from 'react';
import AnalyticsManager from '../utils/AnalyticsManager';

export function useUserLocation(map: google.maps.Map | null) {
  const [userLocation, setUserLocation] = useState<google.maps.LatLngLiteral | null>(null);

  const handleLocateUser = useCallback(() => {
    const analytics = AnalyticsManager.getInstance();
    analytics.trackEvent('locate_me_click', { event_category: 'engagement' });

    if (!navigator.geolocation) {
      analytics.trackEvent('geolocation_failure', { error_code: 'unsupported', event_category: 'engagement' });
      alert("Geolocation is not supported by your browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        setUserLocation(pos);
        map?.setCenter(pos);
        map?.setZoom(15);
        analytics.trackEvent('geolocation_success', { event_category: 'engagement' });
      },
      (error) => {
        console.error("Error getting user location:", error);
        analytics.trackEvent('geolocation_failure', { error_code: error.code, event_category: 'engagement' });
        alert(
          "Could not retrieve your location. Please ensure location services are enabled and granted permission."
        );
      }
    );
  }, [map]);

  // Listen for locateUser events dispatched from other components (e.g. SearchComponent)
  useEffect(() => {
    const handler = () => handleLocateUser();
    window.addEventListener('locateUser', handler);
    return () => window.removeEventListener('locateUser', handler);
  }, [handleLocateUser]);

  return { userLocation, handleLocateUser };
}